'use client'

import { FC } from 'react'
import { ToastContainer } from 'react-toastify'

import { IToastifyProps } from './types'

const Toastfy: FC<IToastifyProps> = ({ children }) => {
  const contextClass = {
    success: 'bg-tertiary-600 text-neutral-white',
    error: 'bg-status-red text-neutral-white',
    info: 'bg-grayscale-400 text-neutral-white',
    warning: 'bg-status-yellow text-neutral-black',
    default: 'bg-grayscale-400 bg-opacity-50 text-neutral-black',
    dark: 'bg-neutral-black text-neutral-white',
  }

  return (
    <>
      {children}
      <ToastContainer
        toastClassName={(context) =>
          contextClass[context?.type || 'default'] +
          'relative flex flex-nowrap gap-2 p-1 min-h-10 rounded-lg justify-between overflow-hidden cursor-pointer'
        }
        // bodyClassName={() => 'flex flex-nowrap gap-2 prose-body-small p-2'}
      />
    </>
  )
}

export default Toastfy
